import React from "react";
import { WorldMap } from "../../maps/world-map";
import { t } from "../../localization/localization";
import { useLocation, useParams } from "react-router-dom";
import { useGetGoogleAnalyticsReportByCountry } from "../../hooks/google-analytics/google-analytics.hook";

export const HandleVistorChart = () => {
  const search = useLocation().search;
  const urlSearchParam = new URLSearchParams(search);
  const locale = urlSearchParam.get("locale");
  const { firstId, secondId } = useParams();

  var date = new Date();
  const { data, isLoading } = useGetGoogleAnalyticsReportByCountry(
    window._env_.GOOGLE_ANALYTICS_START_YEAR,
    date.toISOString().split("T")[0],
    `/handle/${firstId}/${secondId}`,
  );
  return (
    <div>
      <h3>{t(locale, "/rs/profile/google-analytics/visitor-traffic")}</h3>
      {!isLoading && (
        <WorldMap
          mapData={data.rows.map((element) => {
            return { name: element[1], value: element[2] };
          })}
          endDate={date.toISOString().split("T")[0]}
          startDate={window._env_.GOOGLE_ANALYTICS_START_YEAR}
        />
      )}
    </div>
  );
};
